import type { ClaimRequestStatus } from '@icebreaker/shared';
import { type TranslationKey } from '@icebreaker/shared/i18n';
import { useTranslation } from '@/shared/i18n/i18n-provider';
import { Tag, type TagVariant } from '@icebreaker/ui';

/**
 * Talep durumu rozeti — semantik renkler (README 4.2): bekleme kehribar,
 * onay yeşil, red kırmızı (yalnız hata/red), nötr gri. Tam yuvarlak rozet.
 */
const STATUS_META: Record<ClaimRequestStatus, { key: TranslationKey; variant: TagVariant }> = {
  submitted: { key: 'claims.statusSubmitted', variant: 'neutral' },
  evidence_added: { key: 'claims.statusEvidenceAdded', variant: 'neutral' },
  owner_notified: { key: 'claims.statusOwnerNotified', variant: 'info' },
  objection_window: { key: 'claims.statusObjectionWindow', variant: 'warning' },
  objected: { key: 'claims.statusObjected', variant: 'warning' },
  approved: { key: 'claims.statusApproved', variant: 'success' },
  rejected: { key: 'claims.statusRejected', variant: 'danger' },
  withdrawn: { key: 'claims.statusWithdrawn', variant: 'neutral' },
  transferred: { key: 'claims.statusTransferred', variant: 'success' },
};

export function ClaimStatusTag({ status }: { status: ClaimRequestStatus }) {
  const t = useTranslation();
  const meta = STATUS_META[status];
  return <Tag variant={meta.variant}>{t.t(meta.key)}</Tag>;
}
